import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import Hidden from 'material-ui/Hidden';
import Leader from '../components/Leader';
import aboutImg from '../assets/imgAbout.png';
import missionImg from '../assets/imgMission.png';
import colors from '../assets/colors.js'

const styles = theme => ({
  leaderGrid: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  atGlance: {
    backgroundColor: colors.tealLight,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: 'normal',
    padding: '40px',
  },
});

class Home extends React.Component {

  render() {
    const { classes } = this.props;

    return (
      <Grid id="about" container justify='center' alignItems='center' spacing={0} align='left'>
        <Grid item xs={12} md={8} className='sectionText sectionText--top'>
          <h1>Who We Are</h1>
          <p>
            The Erich & Hannah Sachs Foundation (“Foundation”) was established in 1997 by Reynold M. Sachs to honor his parents, World War II immigrants from Germany. Having themselves faced intolerance and economic hardship, Erich &amp; Hannah Sachs developed deep commitments to tolerance and improving the quality of people’s lives, by creating greater economic and educational opportunities for those less fortunate or less able.
          </p>
            <span className='readMoreAbout'>
              <p>
                The Foundation is managed by a small group of professionals, enabling a maximum of its annual funding to go to exemplary charitable programs. The Foundation strives to minimize salaries, overhead and administrative costs, both its own and those of the charitable organizations and institutions it funds.
              </p>
            </span>
        </Grid>
        <Hidden smDown>
          <Grid item md={4} className='sectionImg sectionImg--right'>
            <img src={aboutImg} alt='Boy Smiling' width='100%' />
          </Grid>
        </Hidden>
       <Hidden smDown>
          <Grid item sm={4} className='sectionImg'>
            <img src={missionImg} alt='Growing Plant' width='100%' />
          </Grid>
        </Hidden>
        <Grid item xs={12} md={8} className='sectionText'>
          <h1 className='teal'>Our Mission</h1>
          <p>
            The Foundation's primary commitment is to improving the overall quality of life for economically and/or educationally disadvantaged individuals and families who manifest a genuine desire to help themselves. The Foundation also supports efforts designed to strengthen communities. Priority is given to those charitable organizations and institutions with an established record of increasing economic and educational opportunities in both low-income, inner-city neighborhoods, as well as in rural areas.
          </p>
            <span id='readMoreMission'>
              <p>
                The Foundation provides support in a variety of areas, including: low-income housing, affordable day care, after-school programs, drug rehabilitation clinics, juvenile intervention (pre-incarceration) counseling, job-training, micro-loans to small, family owned businesses in Central and South America, and Africa, rural land/open space preservation, and college scholarship support to exceptional public high school students.
              </p>
            </span>
        </Grid>
        <Grid item xs={12} className={'sectionText ' + classes.atGlance} align='center'>
          <Grid container justify='center' alignItems='stretch'>
            <Grid item xs={12} md={10}>
              <h1 className="teal">At a Glance</h1>
              <Grid container justify='space-around' alignItems='stretch'>
                <Grid item xs={6} md={3}>
                  <i class="material-icons">monetization_on</i>
                  <div>$37M+ IN<br />CUMULATIVE<br />FUNDING TO DATE</div>
                </Grid>
                <Grid item xs={6} md={3}>
                  <i class="material-icons">public</i>
                  <div>OPERATING<br />IN 13 STATES<br />&amp; 3 COUNTRIES</div>
                </Grid>
                <Grid item xs={6} md={3}>
                  <i class="material-icons">favorite</i>
                  <div>CURRENTLY<br />SUPPORTING 27 <br />ORGANIZATIONS</div>
                </Grid>
                <Grid item xs={6} md={3}>
                  <i class="material-icons">mood</i>
                  <div>HAVING A<br />POSITIVE IMPACT<br />SINCE 1997</div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Home);



// WEBPACK FOOTER //
// ./src/views/Home.js